var map = {
	"./bg-exclusive.webp": 1350,
	"./border-bg-sm.png": 1351,
	"./border-bg-xm.png": 1352,
	"./border-bg.png": 1353,
	"./btn-active.png": 1354,
	"./casino-hover.webp": 1355,
	"./cny-flower-1.webp": 1356,
	"./cny-flower-2.webp": 1357,
	"./cny-mobile-bg.webp": 1358,
	"./content-deco-1.webp": 1359,
	"./content-deco-2.webp": 1360,
	"./content-deco-3.webp": 1361,
	"./content-deco-4.webp": 1362,
	"./content-deco-5.webp": 1363,
	"./deposit-icon.webp": 1364,
	"./event-border-hover.webp": 1365,
	"./games-hover.webp": 1366,
	"./home-icon-active.webp": 1367,
	"./home-icon.webp": 1368,
	"./live-icon-active.webp": 1369,
	"./live-icon.webp": 1370,
	"./lottery-hover.webp": 1371,
	"./master-bg.png": 1372,
	"./me-icon-active.webp": 1373,
	"./me-icon.webp": 1374,
	"./p2p-hover.webp": 1375,
	"./platform.webp": 1376,
	"./product-overview-bg.webp": 1377,
	"./promos-icon-active.webp": 1378,
	"./promos-icon.webp": 1379,
	"./slots-hover.webp": 1380,
	"./sponsor-icon-active.webp": 1381,
	"./sponsor-icon.webp": 1382,
	"./sports-hover.webp": 1383,
	"./title-deco-bg.webp": 1384,
	"./title-deco-left.webp": 1385,
	"./title-deco-right.webp": 1386,
	"./vip-icon-active.webp": 1387,
	"./vip-icon.webp": 1388,
	"./withdraw-icon.webp": 1389,
	"./wwr-bg.webp": 1390,
	"./wwr-img.webp": 1391
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 150;